import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  textColor: {
    color: "text.primary",
  },
  tableHeaderText: {
    color: "text.primary",
  },
  memberText: {
    "& .MuiTypography-root": {
      color: "text.primary",
      fontSize: "14px",
      paddingLeft: "16px !important",
    },
  },
  delete: {
    "& .MuiSvgIcon-root": {
      color: "text.primary",
    },
  },
  eventList: {
    "& .MuiList-root": {
      padding: "0px",
    },
    "& ul": {
      maxHeight: "300px",
    },
  },
  confirm: {
    minWidth: "133px",
  },
  dismiss: {
    minWidth: "127px",
  },
  roleEdit: {
    minWidth: "270px",
    display: "flex",
    flexDirection: "column",
  },
  option: {
    height: "50px",
    padding: "10px 10px 0px",
    letterSpacing: "0px",
    color: "text.primary",
    opacity: 1,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  info: {
    flexGrow: 1,
  },
  title: {
    fontSize: "14px",
    lineHeight: "19px",
    fontWeight: "500",
  },
  desc: {
    fontSize: "12px",
    lineHeight: "21px",
  },
  icons: {
    width: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
  },
  remove: {
    fontWeight: 500,
    color: "error.dark",
  },
  icon: {
    marginRight: "10px",
    color: "error.dark",
  },
  selectedOption: (selectedMember: string | null, role: string) => ({
    backgroundColor:
      selectedMember === role ? "events.bluePrimary" : "transparent",
    color: selectedMember === role ? "white" : "text.primary",
  }),
  selectedButton: {
    color: (theme: Theme) => `${theme.palette.events.blueSecondary} !important`,
    backgroundColor: (theme: Theme) =>
      `${theme.palette.events.blueShade2} !important`,
  },
  eventText: {
    paddingLeft: "0px !important",
  },
};
